import React, { useContext } from 'react';
import { useQuery } from '@tanstack/react-query';
import { FilterCollection, views } from 'plato-js-client';
import { Table } from 'reactstrap';
import { addTab } from '../Actions';
import { Store } from '../Store';
import Icon from '../components/Icon';

const relevantWorkOrderStatuses = [
    'Approved',
    'Completed',
    'Financially Completed',
    'Invoice Approved',
    'Invoice Rejected',
    'Invoiced',
    'Owner Charged',
    'Started',
    'Supplier Paid',
].join('|');

export function TabChecklistResponses({ propertyId }) {
    const { data, isError, isFetching, isFetched } = useQuery({
        queryKey: ['property.checklist.responses', { propertyId }],
        queryFn: async () => {
            const propertyWorkOrders = new FilterCollection({
                path: 'workorder',
                object: views.PropertyChecklistResponsesView
            });

            propertyWorkOrders.view = 'pms';
            propertyWorkOrders.orderBy = 'id_desc';
            propertyWorkOrders.addFilter('type', 'Instance');
            propertyWorkOrders.addFilter('answers', 1);
            propertyWorkOrders.addFilter('propertyid', propertyId);
            propertyWorkOrders.addFilter('status', relevantWorkOrderStatuses);

            await propertyWorkOrders.fetch();
            return propertyWorkOrders.collection.flatMap(aggregate => aggregate.responses);
        },
        placeholderData: []
    });

    if (isError) {
        return (
            <div>Oops, something went wrong.</div>
        );
    }

    if (isFetching) {
        return (
            <div>Loading...</div>
        );
    }

    if (!isFetched) {
        return null;
    }

    if (data.length < 1) {
        return (
            <div>
                No checklists have been submitted for this property.
            </div>
        )
    }

    return (
        <Table
            size="sm"
            striped
        >
            <thead>
            <tr>
                <th>Work</th>
                <th>Checklist</th>
                <th>Date</th>
                <th>{ '' }</th>
            </tr>
            </thead>
            <tfoot></tfoot>
            <tbody>
            { data.map((rowView, x) => (
                <ChecklistRow
                    key={ `woi-checklist-${ x }` }
                    rowView={ rowView }
                />
            )) }
            </tbody>
        </Table>
    );
}

function ChecklistRow({ rowView }) {
    const { dispatch } = useContext(Store);

    return (
        <tr>
            <td>{ rowView.workOrderType }</td>
            <td>{ rowView.checklistName }</td>
            <td>{ rowView.responseSubmittedDate }</td>
            <td>
                <Icon
                    icon="pencil-alt"
                    onClick={ () => addTab('editJob', { workOrderId: rowView.workOrderId }, dispatch) }
                />
            </td>
        </tr>
    );
}
